__turbopack_context__.v({
  "availability": "immersive-shop-module__Lh8yjG__availability",
  "cartReviewCard": "immersive-shop-module__Lh8yjG__cartReviewCard",
  "cartReviewCheckout": "immersive-shop-module__Lh8yjG__cartReviewCheckout",
  "cartReviewClose": "immersive-shop-module__Lh8yjG__cartReviewClose",
  "cartReviewHeader": "immersive-shop-module__Lh8yjG__cartReviewHeader",
  "cartReviewImage": "immersive-shop-module__Lh8yjG__cartReviewImage",
  "cartReviewIn": "immersive-shop-module__Lh8yjG__cartReviewIn",
  "cartReviewInfo": "immersive-shop-module__Lh8yjG__cartReviewInfo",
  "cartReviewOverlay": "immersive-shop-module__Lh8yjG__cartReviewOverlay",
  "cartReviewProductLink": "immersive-shop-module__Lh8yjG__cartReviewProductLink",
  "cartReviewQuantity": "immersive-shop-module__Lh8yjG__cartReviewQuantity",
  "cartReviewRecap": "immersive-shop-module__Lh8yjG__cartReviewRecap",
  "cartReviewRemove": "immersive-shop-module__Lh8yjG__cartReviewRemove",
  "cartReviewRow": "immersive-shop-module__Lh8yjG__cartReviewRow",
  "cartReviewSubtitle": "immersive-shop-module__Lh8yjG__cartReviewSubtitle",
  "cartReviewTitle": "immersive-shop-module__Lh8yjG__cartReviewTitle",
  "cartReviewTotals": "immersive-shop-module__Lh8yjG__cartReviewTotals",
  "cartReviewUpdating": "immersive-shop-module__Lh8yjG__cartReviewUpdating",
  "coverflowCarouselSlot": "immersive-shop-module__Lh8yjG__coverflowCarouselSlot",
  "coverflowDock": "immersive-shop-module__Lh8yjG__coverflowDock",
  "coverflowDockBehind": "immersive-shop-module__Lh8yjG__coverflowDockBehind",
  "coverflowPreview": "immersive-shop-module__Lh8yjG__coverflowPreview",
  "coverflowPreviewClosing": "immersive-shop-module__Lh8yjG__coverflowPreviewClosing",
  "coverflowPrice": "immersive-shop-module__Lh8yjG__coverflowPrice",
  "coverflowTitle": "immersive-shop-module__Lh8yjG__coverflowTitle",
  "detailsLink": "immersive-shop-module__Lh8yjG__detailsLink",
  "emptyState": "immersive-shop-module__Lh8yjG__emptyState",
  "galleryActionButton": "immersive-shop-module__Lh8yjG__galleryActionButton",
  "galleryActions": "immersive-shop-module__Lh8yjG__galleryActions",
  "galleryCartBadge": "immersive-shop-module__Lh8yjG__galleryCartBadge",
  "galleryLogo": "immersive-shop-module__Lh8yjG__galleryLogo",
  "galleryMenuBarBottom": "immersive-shop-module__Lh8yjG__galleryMenuBarBottom",
  "galleryMenuBarMid": "immersive-shop-module__Lh8yjG__galleryMenuBarMid",
  "galleryMenuBarTop": "immersive-shop-module__Lh8yjG__galleryMenuBarTop",
  "galleryMenuItem": "immersive-shop-module__Lh8yjG__galleryMenuItem",
  "galleryMenuItems": "immersive-shop-module__Lh8yjG__galleryMenuItems",
  "galleryMenuToggle": "immersive-shop-module__Lh8yjG__galleryMenuToggle",
  "modalClose": "immersive-shop-module__Lh8yjG__modalClose",
  "modalContent": "immersive-shop-module__Lh8yjG__modalContent",
  "modalContentClosing": "immersive-shop-module__Lh8yjG__modalContentClosing",
  "modalDescription": "immersive-shop-module__Lh8yjG__modalDescription",
  "modalFadeIn": "immersive-shop-module__Lh8yjG__modalFadeIn",
  "modalFadeOut": "immersive-shop-module__Lh8yjG__modalFadeOut",
  "modalFall": "immersive-shop-module__Lh8yjG__modalFall",
  "modalGallery": "immersive-shop-module__Lh8yjG__modalGallery",
  "modalGalleryCount": "immersive-shop-module__Lh8yjG__modalGalleryCount",
  "modalGalleryImage": "immersive-shop-module__Lh8yjG__modalGalleryImage",
  "modalGallerySlide": "immersive-shop-module__Lh8yjG__modalGallerySlide",
  "modalInfo": "immersive-shop-module__Lh8yjG__modalInfo",
  "modalMedia": "immersive-shop-module__Lh8yjG__modalMedia",
  "modalOverlay": "immersive-shop-module__Lh8yjG__modalOverlay",
  "modalOverlayClosing": "immersive-shop-module__Lh8yjG__modalOverlayClosing",
  "modalOverlayCoverflow": "immersive-shop-module__Lh8yjG__modalOverlayCoverflow",
  "modalRise": "immersive-shop-module__Lh8yjG__modalRise",
  "modalTitle": "immersive-shop-module__Lh8yjG__modalTitle",
  "orbEmptyState": "immersive-shop-module__Lh8yjG__orbEmptyState",
  "orbStage": "immersive-shop-module__Lh8yjG__orbStage",
  "orbStageSwipe": "immersive-shop-module__Lh8yjG__orbStageSwipe",
  "pinSlideIn": "immersive-shop-module__Lh8yjG__pinSlideIn",
  "pinToCartButton": "immersive-shop-module__Lh8yjG__pinToCartButton",
  "pinToCartButtonActive": "immersive-shop-module__Lh8yjG__pinToCartButtonActive",
  "pinnedError": "immersive-shop-module__Lh8yjG__pinnedError",
  "pinnedImage": "immersive-shop-module__Lh8yjG__pinnedImage",
  "pinnedInfo": "immersive-shop-module__Lh8yjG__pinnedInfo",
  "pinnedItem": "immersive-shop-module__Lh8yjG__pinnedItem",
  "pinnedMeta": "immersive-shop-module__Lh8yjG__pinnedMeta",
  "pinnedPrice": "immersive-shop-module__Lh8yjG__pinnedPrice",
  "pinnedTitle": "immersive-shop-module__Lh8yjG__pinnedTitle",
  "pinnedTray": "immersive-shop-module__Lh8yjG__pinnedTray",
  "productLabel": "immersive-shop-module__Lh8yjG__productLabel",
  "productOrb": "immersive-shop-module__Lh8yjG__productOrb",
  "productOrbControl": "immersive-shop-module__Lh8yjG__productOrbControl",
  "productOrbControlCompact": "immersive-shop-module__Lh8yjG__productOrbControlCompact",
  "productOrbControlInteractive": "immersive-shop-module__Lh8yjG__productOrbControlInteractive",
  "productOrbImage": "immersive-shop-module__Lh8yjG__productOrbImage",
  "productOrbNode": "immersive-shop-module__Lh8yjG__productOrbNode",
  "productOrbNodeCompact": "immersive-shop-module__Lh8yjG__productOrbNodeCompact",
  "productOrbPlaceholder": "immersive-shop-module__Lh8yjG__productOrbPlaceholder",
  "productPageFloatingActionsScope": "immersive-shop-module__Lh8yjG__productPageFloatingActionsScope",
  "productPrice": "immersive-shop-module__Lh8yjG__productPrice",
  "productSearchArrow": "immersive-shop-module__Lh8yjG__productSearchArrow",
  "productSearchClose": "immersive-shop-module__Lh8yjG__productSearchClose",
  "productSearchEmpty": "immersive-shop-module__Lh8yjG__productSearchEmpty",
  "productSearchField": "immersive-shop-module__Lh8yjG__productSearchField",
  "productSearchOverlay": "immersive-shop-module__Lh8yjG__productSearchOverlay",
  "productSearchOverlayClosing": "immersive-shop-module__Lh8yjG__productSearchOverlayClosing",
  "productSearchPanel": "immersive-shop-module__Lh8yjG__productSearchPanel",
  "productSearchResult": "immersive-shop-module__Lh8yjG__productSearchResult",
  "productSearchResultImage": "immersive-shop-module__Lh8yjG__productSearchResultImage",
  "productSearchResultInfo": "immersive-shop-module__Lh8yjG__productSearchResultInfo",
  "productSearchResults": "immersive-shop-module__Lh8yjG__productSearchResults",
  "productSearchSubmit": "immersive-shop-module__Lh8yjG__productSearchSubmit",
  "quickViewActions": "immersive-shop-module__Lh8yjG__quickViewActions",
  "quickViewPrimaryActions": "immersive-shop-module__Lh8yjG__quickViewPrimaryActions",
  "selectionCount": "immersive-shop-module__Lh8yjG__selectionCount",
  "selector": "immersive-shop-module__Lh8yjG__selector",
  "selectorAccessibleLabel": "immersive-shop-module__Lh8yjG__selectorAccessibleLabel",
  "selectorArrow": "immersive-shop-module__Lh8yjG__selectorArrow",
  "selectorArrowIcon": "immersive-shop-module__Lh8yjG__selectorArrowIcon",
  "selectorLabel": "immersive-shop-module__Lh8yjG__selectorLabel",
  "selectorLabelViewport": "immersive-shop-module__Lh8yjG__selectorLabelViewport",
  "shopBody": "immersive-shop-module__Lh8yjG__shopBody",
  "subcategoryCluster": "immersive-shop-module__Lh8yjG__subcategoryCluster",
  "subcategoryOrbItem": "immersive-shop-module__Lh8yjG__subcategoryOrbItem",
  "subcategoryOrbLabel": "immersive-shop-module__Lh8yjG__subcategoryOrbLabel",
  "subcategoryView": "immersive-shop-module__Lh8yjG__subcategoryView",
  "subcategoryViewIn": "immersive-shop-module__Lh8yjG__subcategoryViewIn",
  "subcategoryViewInMobile": "immersive-shop-module__Lh8yjG__subcategoryViewInMobile",
  "unpinButton": "immersive-shop-module__Lh8yjG__unpinButton",
  "variantOptionButton": "immersive-shop-module__Lh8yjG__variantOptionButton",
  "variantOptionButtonActive": "immersive-shop-module__Lh8yjG__variantOptionButtonActive",
  "variantOptionGroup": "immersive-shop-module__Lh8yjG__variantOptionGroup",
  "variantOptionTitle": "immersive-shop-module__Lh8yjG__variantOptionTitle",
  "variantOptionValues": "immersive-shop-module__Lh8yjG__variantOptionValues",
  "variantSelector": "immersive-shop-module__Lh8yjG__variantSelector",
  "wrapper": "immersive-shop-module__Lh8yjG__wrapper",
});
